export default ({ checked }) => [
  {
    type: 'dropdown',
    text: 'Действия с выделенными',
    variant: 'outline-info',
    class: 'mr-2',
    bulk: true,
    disabled: checked && checked.length === 0,
    items: [
      {
        type: 'button',
        text: 'Удалить',
        icon: 'fa-times',
        action: 'removeChecked',
        permission: 'all',
      },
    ],
  },
  {
    type: 'button',
    text: 'Добавить дистрибьютора',
    variant: 'info',
    icon: 'fa-plus',
    class: 'mr-1',
    action: 'openCreateForm',
    permission: 'all',
  },

];
